import { SurveyStatus } from './../../Views/Surveys/SurveysTypes.d';
import { rootElement } from '@shared/setup';
import Root from '@shared/Root/Root.vue';
import { createRouter, createWebHistory, RouterView } from 'vue-router';
import { defineComponent } from 'vue';
import FormsList from '@views/Web/FormsList/FormsList.vue';
import FormEditor from '@views/Web/FormEditor/FormEditor.vue';
import MediaMonitorCreateNew from '@views/MediaMonitors/MediaMonitorCreateNew.vue';
import MediaMonitorsList from '@views/MediaMonitors/MediaMonitorsList.vue';
import MediaMonitor from '@views/MediaMonitors/MediaMonitor.vue';
import AccountEvaluation from '@views/Account/AccountEvaluation/AccountEvaluation.vue';
import PaymentFailed from '@views/Account/PaymentFailed/PaymentFailed.vue';
import TextMessagesList from '@views/TextMessages/List/List.vue';
import NewTextMessage from '@views/TextMessages/Pages/New.vue';
import TextMessagesKeywords from '@views/TextMessages/Pages/Keywords.vue';
import TextMessagesResponses from '@views/TextMessages/Pages/Responses.vue';
import TextMessageSending from '@views/TextMessages/Pages/Sending.vue';
import SmsDialogs from '@views/TextMessages/Pages/SmsDialogs.vue';
import Contact from '@views/Contact/Contact.vue';
import SurveysList from '@views/Surveys/List.vue';
import SurveysNew from '@views/Surveys/New.vue';
import SegmentsRoot from '@views/Segments/SegmentsRoot.vue';
import SurveyPublished from '@views/Surveys/Published.vue';
import ViewsRoot from '@views/ViewsRoot.vue';
import BackOfficeRoot from '@cwd/Views/BackOffice/BackOfficeRoot.vue';
import AccountList from '@cwd/Views/BackOffice/Account/AccountList.vue';
import AccountEdit from '@cwd/Views/BackOffice/Account/AccountEdit.vue';
import SubscriptionList from '@cwd/Views/BackOffice/Subscription/SubscriptionList.vue';
import SubscriptionEdit from '@cwd/Views/BackOffice/Subscription/SubscriptionEdit.vue';
import UserList from '@cwd/Views/BackOffice/User/UserList.vue';
import UserEdit from '@cwd/Views/BackOffice/User/UserEdit.vue';
import Features from '@cwd/Views/BackOffice/Features/Features.vue';
import FeatureSets from '@cwd/Views/BackOffice/FeatureSets/FeatureSets.vue';
import ServiceSubscriptionStats from '@cwd/Views/BackOffice/ServiceSubscriptionStats/ServiceSubscriptionStats.vue';
import UnsubscribeReasonStats from '@cwd/Views/BackOffice/UnsubscribeReasonStats/UnsubscribeReasonStats.vue';
import ManageUsers from '@cwd/Views/BackOffice/ManageUsers/ManageUsers.vue';
import TaskManager from '@cwd/Views/BackOffice/TaskManager/TaskManager.vue';
import SegmentsList from '@cwd/Views/Segments/SegmentsList.vue';
import SegmentsEdit from '@cwd/Views/Segments/SegmentsEdit.vue';
import JourneyHome from '@journeys/Pages/JourneyStart.vue';
import JourneyNew from '@journeys/Pages/JourneyNew.vue';
import Viewport from '@journeys/components/Viewport.vue';
import JourneysRoot from '@journeys/JourneysRoot.vue';
import EventList from '@views/Event/EventList.vue';
import EventSponsors from '@views/Event/Sponsors.vue';
import EventSponsor from '@views/Event/Sponsor.vue';
import EventsNew from '@views/Event/New.vue';
import Dashboard from '@cwd/Views/Dashboard/Dashboard.vue';
import SmtpServers from '@views/BackOffice/SmtpServers/SmtpServers.vue';
import SmtpServerDetails from '@views/BackOffice/SmtpServers/SmtpServerDetails.vue';
import OAuthProviderList from '@cwd/Views/BackOffice/OAuthProvider/OAuthProviderList.vue';
import EditOAuthProvider from '@cwd/Views/BackOffice/OAuthProvider/EditOAuthProvider.vue';
import OAuthProviderAuditLogList from '@cwd/Views/BackOffice/OAuthProvider/OAuthProviderAuditLogList.vue';
import LatestIssues from '@cwd/Views/BackOffice/LatestIssues/LatestIssues.vue';
import FeatureFlags from '@cwd/Views/BackOffice/FeatureFlags/FeatureFlags.vue';
import Administrators from '@cwd/Views/BackOffice/Administrators/Administrators.vue';
import LatestSms from '@cwd/Views/BackOffice/LatestSms/LatestSms.vue';
import Miscellaneous from '@cwd/Views/BackOffice/Miscellaneous/Miscellaneous.vue';
import Pricing from '@cwd/Views/BackOffice/Pricing/Pricing.vue';
import GlobalTemplates from '@cwd/Views/BackOffice/GlobalTemplates/GlobalTemplates.vue';
import SubscriptionsDashboard from '@cwd/Views/BackOffice/SubscriptionsDashboard/SubscriptionsDashboard.vue';
import MessageManager from '@cwd/Views/BackOffice/MessageManager/MessageManager.vue';
import Billing from '@cwd/Views/BackOffice/Billing/Billing.vue';
import BillingRenewals from '@cwd/Views/BackOffice/Billing/BillingRenewals.vue';
import BillingOrders from '@cwd/Views/BackOffice/Billing/BillingOrders.vue';
import BillingInvoices from '@cwd/Views/BackOffice/Billing/BillingInvoices.vue';
import BillingRegisterPayment from '@cwd/Views/BackOffice/Billing/BillingRegisterPayment.vue';
import BillingUnresolved from '@cwd/Views/BackOffice/Billing/BillingUnresolved.vue';
import BillingAccountsReceivable from '@cwd/Views/BackOffice/Billing/BillingAccountsReceivable.vue';
import BillingMonthlyReport from '@cwd/Views/BackOffice/Billing/BillingMonthlyReport.vue';
import BillingNeedToPay from '@cwd/BackOffice/NeedToPay/NeedToPay.vue';
import BillingTransactions from '@cwd/BackOffice/CreditCardTransactions/CreditCardTransactions.vue';
import Speakers from '@views/Event/Speakers.vue';
import Speaker from '@views/Event/Speaker.vue';
import BackOfficeDashboard from '@cwd/Views/BackOffice/Dashboard/BackOfficeDashboard.vue';
import HealthManager from '@cwd/Views/BackOffice/HealthManager/HealthManager.vue';
import WorkerManagement from '@cwd/Views/BackOffice/WorkerManagement/WorkerManagement.vue';
import Deliverability from '@cwd/Views/BackOffice/Deliverability/Deliverability.vue';
import IssuesList from '@views/Issues/List.vue';
import IssuesNew from '@views/Issues/New.vue';
import IssueStatistics from '@views/Issues/IssueStatistics/IssueStatistics.vue';
import TextMessageStatistics from '@cwd/Views/TextMessages/Statistics/TextMessageStatistics.vue';
import TaskListing from '@cwd/Views/Automation/Task/TaskListing.vue';
import TaskItem from '@cwd/Views/Automation/Task/TaskItem.vue';
import Import from '@cwd/Views/Lists/Import/Import.vue';
import Lists from '@cwd/Views/Lists/Lists.vue';
import List from '@cwd/Views/Lists/List.vue';
import Changelog from '@views/Changelog/Changelog.vue';
import Updates from '@views/Updates/Updates.vue';
import ProcessingTasks from '@cwd/Views/ProcessingTasks/ProcessingTasks.vue';
import Contacts from '@views/Contacts/Contacts.vue';
import ImageLibrary from '@views/ImageLibrary/ImageLibrary.vue';
import AccountRoot from '@views/Account/AccountRoot.vue';
import UserProfile from '@views/Account/UserProfile.vue';
import AccountUsers from '@views/Account/AccountUsers.vue';
import AccountInfo from '@views/Account/AccountInfo.vue';
import AccountGeneralSettings from '@views/Account/AccountGeneralSettings.vue';
import AccountMailSettings from '@views/Account/AccountMailSettings.vue';
import AccountSubscriptionCategories from '@views/Account/AccountSubscriptionCategories.vue';
import AccountTagManager from '@views/Account/AccountTagManager.vue';
import AccountThemes from '@views/Account/AccountThemes.vue';
import AccountSubscription from '@views/Account/AccountSubscription.vue';
import AccountBillingDetails from '@views/Account/AccountBillingDetails.vue';
import AccountInvoices from '@views/Account/AccountInvoices.vue';
import AccountCreditCards from '@views/Account/AccountCreditCards.vue';
import AccountTransactions from '@views/Account/AccountTransactions.vue';
import AccountPrePaidBalance from '@views/Account/AccountPrePaidBalance.vue';
import AccountApiKeys from '@views/Account/AccountApiKeys.vue';
import AccountConnections from '@views/Account/AccountConnections.vue';
import AccountDataManagement from '@views/Account/AccountDataManagement.vue';
import AccountProcessingTasks from '@views/Account/AccountProcessingTasks.vue';
import SurveyStatistics from '@views/Surveys/SurveyStatistics/SurveyStatistics.vue';
import SurveyStatisticsRespondents from '@views/Surveys/SurveyStatistics/components/StatisticsRespondents.vue';
import SurveyStatisticsResponses from '@views/Surveys/SurveyStatistics/components/StatisticsResponses.vue';
import SurveyStatisticsResponseDetail from '@views/Surveys/SurveyStatistics/components/StatisticsResponseDetail.vue';

const initVueRoot = async () => {
    const routes: any[] = [
        {
            path: '/Account/PaymentFailed',
            name: 'PaymentFailed',
            component: PaymentFailed,
        },
        {
            path: '/Account/Evaluation',
            name: 'AccountEvaluation',
            component: AccountEvaluation,
        },
        {
            path: '/Dashboard',
            component: ViewsRoot,
            children: [{ path: '', name: 'Dashboard', component: Dashboard }],
        },
        {
            path: '/MediaMonitors',
            component: ViewsRoot,
            children: [
                { path: '', name: 'MediaMonitors', component: MediaMonitorsList },
                { path: 'New', name: 'NewMediaMonitor', component: MediaMonitorCreateNew },
                { path: ':id', name: 'MediaMonitor', component: MediaMonitor, props: true },
            ],
        },
        {
            path: '/Web/Forms',
            component: ViewsRoot,
            children: [
                { path: '', name: 'Forms', component: FormsList, props: true },
                { path: 'new', name: 'FormsNew', component: FormEditor, props: true },
                { path: 'copy/:copyFromWebContentId', name: 'FormsCopy', component: FormEditor, props: true },
                {
                    path: 'edit/:webContentId',
                    component: FormEditor,
                    name: 'FormsEditor',
                    props: true,
                },
            ],
        },
        {
            path: '/TextMessages',
            component: ViewsRoot,
            children: [
                { path: '', name: 'TextMessages', component: TextMessagesList },
                { path: 'new', name: 'NewTextMessage', component: NewTextMessage },
                { path: 'keywords', name: 'TextMessagesKeywords', component: TextMessagesKeywords },
                { path: 'responses', name: 'TextMessagesResponses', component: TextMessagesResponses },
                { path: 'responses/contact/:contactId', name: 'ResponseContact', component: Contact, props: true },
                { path: 'responses', name: 'TextMessagesResponses', component: TextMessagesResponses },
                { path: 'smsdialogs', name: 'SmsDialogs', component: SmsDialogs },
                { path: ':textMessageId/sending', name: 'TextMessageSending', component: TextMessageSending, props: true },
                {
                    path: ':smsMessageId/Statistics',
                    name: 'TextMessageStatistics',
                    component: TextMessageStatistics,
                    props: true,
                    children: [
                        {
                            path: 'Contacts/:contactType',
                            name: 'TextMessageStatisticsContacts',
                            component: RouterView,
                            props: true,
                            children: [{ path: 'Contact/:contactId', name: 'TextMessageStatisticsContact', component: Contact, props: true }],
                        },
                    ],
                },
            ],
        },
        {
            path: '/Contact',
            component: ViewsRoot,
            children: [{ path: ':contactId', name: 'Contact', component: Contact, props: true }],
        },
        {
            path: '/Surveys',
            component: ViewsRoot,
            children: [
                { path: '', name: 'Surveys', component: SurveysList },
                { path: 'new', name: 'SurveysNew', component: SurveysNew },
                { path: ':surveyId/published', name: 'SurveyPublished', component: SurveyPublished, props: true },
                {
                    path: ':surveyId/Results',
                    name: 'SurveyStatistics',
                    component: SurveyStatistics,
                    props: true,
                    children: [
                        {
                            path: 'Respondents',
                            name: 'SurveyStatisticsRespondents',
                            component: SurveyStatisticsRespondents,
                            props: true,
                        },
                        { path: 'Respondents/Contact/:contactId', name: 'SurveyStatisticsRespondentContact', component: Contact, props: true },
                        {
                            path: 'Responses',
                            name: 'SurveyStatisticsResponses',
                            component: SurveyStatisticsResponses,
                            props: true,
                        },
                        {
                            path: 'Responses/Contact/:contactId',
                            name: 'SurveyStatisticsResponsesForContact',
                            component: SurveyStatisticsResponses,
                            props: true,
                        },
                        {
                            path: 'Responses/ContactDetail/:contactId',
                            name: 'SurveyStatisticsResponseContact',
                            component: Contact,
                            props: true,
                        },
                        { path: 'Responses/:responseId', name: 'SurveyStatisticsResponse', component: SurveyStatisticsResponseDetail, props: true },
                    ],
                },
            ],
        },
        {
            path: '/Events',
            component: ViewsRoot,
            children: [
                { path: '', name: 'Events', component: EventList },
                { path: 'new', name: 'EventsNew', component: EventsNew },
                { path: 'sponsors', name: 'EventSponsors', component: EventSponsors },
                { path: 'sponsors/new', name: 'EventSponsorNew', component: EventSponsor },
                { path: 'sponsors/:sponsorId', name: 'EventSponsor', component: EventSponsor, props: true },
                { path: 'speakers', name: 'EventSpeakers', component: Speakers },
                { path: 'speakers/new', name: 'EventSpeakerNew', component: Speaker },
                { path: 'speakers/:speakerId', name: 'EventSpeaker', component: Speaker, props: true },
            ],
        },
        {
            path: '/Segments',
            component: ViewsRoot,
            children: [
                {
                    path: '',
                    component: SegmentsRoot,
                    name: 'SegmentsRoot',
                    children: [
                        { path: '', name: 'Segments', component: SegmentsList },
                        {
                            path: ':segmentId',
                            name: 'SegmentEdit',
                            component: SegmentsEdit,
                            props: true,
                        },
                    ],
                },
            ],
        },
        {
            path: '/Journeys',
            component: ViewsRoot,
            children: [
                {
                    path: '',
                    component: JourneysRoot,
                    name: 'JourneysRoot',
                    children: [
                        { path: '', redirect: { name: 'JourneyHome', params: { status: 'drafts' } } },
                        { path: ':status(drafts|active|ended|templates)', component: JourneyHome, props: true, name: 'JourneyHome' },
                        { path: 'new', component: JourneyNew, props: true, name: 'JourneyNew' },
                        {
                            path: ':JourneyId([\\w\\-]{36})',
                            component: Viewport,
                            props: true,
                            name: 'JourneyViewport',
                        },
                    ],
                },
            ],
        },
        {
            path: '/BackOffice',
            component: ViewsRoot,
            children: [
                {
                    path: '',
                    component: BackOfficeRoot,
                    name: 'BackOffice',
                    children: [
                        { path: '', redirect: { name: 'AccountList' } },
                        { path: 'Dashboard', name: 'BackOfficeDashboard', component: BackOfficeDashboard },
                        { path: 'Health', name: 'HealthManager', component: HealthManager },
                        { path: 'SubscriptionStats', name: 'SubscriptionStats', component: ServiceSubscriptionStats },
                        { path: 'UnsubscribeReasonStats', name: 'UnsubscribeReasonStats', component: UnsubscribeReasonStats },
                        { path: 'Accounts', name: 'AccountList', component: AccountList },
                        { path: 'Accounts/:accountId', name: 'AccountEdit', component: AccountEdit, props: true },
                        { path: 'Subscriptions', name: 'SubscriptionList', component: SubscriptionList },
                        { path: 'Subscriptions/:serviceSubscriptionId', name: 'SubscriptionEdit', component: SubscriptionEdit, props: true },
                        { path: 'Users', name: 'UserList', component: UserList },
                        { path: 'Users/:userId', name: 'UserEdit', component: UserEdit, props: true },
                        { path: 'Features', name: 'Features', component: Features },
                        { path: 'FeatureSets', name: 'FeatureSets', component: FeatureSets },
                        { path: 'ManageUsers', name: 'ManageUsers', component: ManageUsers },
                        { path: 'ManageWorkers', name: 'ManageWorkers', component: WorkerManagement },
                        { path: 'TaskManager', name: 'TaskManager', component: TaskManager },
                        { path: 'SmtpServers', name: 'SmtpServers', component: SmtpServers },
                        { path: 'SmtpServers/:smtpServerId', name: 'SmtpServerDetail', component: SmtpServerDetails, props: true },
                        { path: 'OAuthProviders', name: 'OAuthProviders', component: OAuthProviderList },
                        { path: 'OAuthProviders/New', name: 'NewOAuthProvider', component: EditOAuthProvider },
                        { path: 'OAuthProviders/:oauthProviderId', name: 'EditOAuthProvider', component: EditOAuthProvider, props: true },
                        { path: 'OAuthProviders/:oauthProviderId/AuditLog', name: 'OAuthProviderAuditLog', component: OAuthProviderAuditLogList, props: true },
                        { path: 'LatestIssues', name: 'LatestIssues', component: LatestIssues },
                        { path: 'Deliverability', name: 'Deliverability', component: Deliverability },
                        { path: 'FeatureFlags', name: 'FeatureFlags', component: FeatureFlags },
                        { path: 'Administrators', name: 'Administrators', component: Administrators },
                        { path: 'LatestSms', name: 'LatestSms', component: LatestSms },
                        { path: 'Miscellaneous', name: 'Miscellaneous', component: Miscellaneous },
                        { path: 'Pricing', name: 'Pricing', component: Pricing },
                        { path: 'GlobalTemplates', name: 'GlobalTemplates', component: GlobalTemplates },
                        { path: 'SubscriptionsDashboard', name: 'SubscriptionsDashboard', component: SubscriptionsDashboard },
                        { path: 'MessageManager', name: 'MessageManager', component: MessageManager },
                        {
                            path: 'Billing',
                            component: Billing,
                            children: [
                                { path: '', redirect: 'Renewals' },
                                { path: 'Renewals', name: 'BillingRenewals', component: BillingRenewals },
                                { path: 'Orders', name: 'BillingOrders', component: BillingOrders },
                                { path: 'Invoices', name: 'BillingInvoices', component: BillingInvoices },
                                { path: 'RegisterPayment', name: 'BillingRegisterPayment', component: BillingRegisterPayment },
                                { path: 'Unresolved', name: 'BillingUnresolved', component: BillingUnresolved },
                                { path: 'AccountsReceivable', name: 'BillingAccountsReceivable', component: BillingAccountsReceivable },
                                { path: 'MonthlyReport', name: 'BillingMonthlyReport', component: BillingMonthlyReport },
                                { path: 'NeedToPay', name: 'BillingNeedToPay', component: BillingNeedToPay },
                                { path: 'Transactions', name: 'BillingTransactions', component: BillingTransactions },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            path: '/Issues',
            component: ViewsRoot,
            children: [
                { path: '', name: 'Issues', component: IssuesList },
                { path: 'New', name: 'IssuesNew', component: IssuesNew },
                {
                    path: ':issueId/Statistics',
                    name: 'IssueStatistics',
                    component: IssueStatistics,
                    props: true,
                    children: [
                        {
                            path: 'Contacts/:contactType',
                            name: 'IssueStatisticsContacts',
                            component: RouterView,
                            props: true,
                            children: [{ path: 'Contact/:contactId', name: 'IssueStatisticsContact', component: Contact, props: true }],
                        },
                    ],
                },
            ],
        },
        {
            path: '/Lists',
            component: ViewsRoot,
            children: [
                { path: '', name: 'Lists', component: Lists },
                {
                    path: ':listId',
                    name: 'List',
                    component: List,
                    props: true,
                    children: [
                        { path: 'Contact/:contactId', name: 'ContactInList', component: Contact, props: true },
                        {
                            path: 'Import',
                            name: 'ListImport',
                            component: Import,
                            props: true,
                        },
                    ],
                },
            ],
        },
        {
            path: '/Changelog',
            component: ViewsRoot,
            children: [{ path: '', name: 'Changelog', component: Changelog }],
        },
        {
            path: '/Updates',
            component: ViewsRoot,
            children: [{ path: '', name: 'Updates', component: Updates }],
        },
        {
            path: '/Automation',
            component: ViewsRoot,
            children: [
                { path: 'Tasks/:taskId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})', name: 'TaskItem', component: TaskItem, props: true },
                {
                    path: 'Tasks/:status/:objectId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})',
                    name: 'TaskListingFiltered',
                    component: TaskListing,
                    props: true,
                },
                { path: 'Tasks/:status?', name: 'TaskListing', component: TaskListing, props: true },
            ],
        },
        {
            path: '/Contacts',
            component: ViewsRoot,
            children: [
                {
                    path: '',
                    name: 'Contacts',
                    component: Contacts,
                    children: [{ path: 'Contact/:contactId', name: 'ContactInContacts', component: Contact, props: true }],
                },
            ],
        },
        {
            path: '/ProcessingTasks',
            component: ViewsRoot,
            children: [{ path: '', name: 'ProcessingTasks', component: ProcessingTasks }],
        },
        {
            path: '/ImageLibrary',
            component: ViewsRoot,
            children: [{ path: '', name: 'ImageLibrary', component: ImageLibrary }],
        },
        {
            path: '/Account',
            component: ViewsRoot,
            children: [
                {
                    path: '',
                    name: 'AccountRoot',
                    component: AccountRoot,
                    children: [
                        { path: '', redirect: { name: 'UserProfile' } },
                        { path: 'UserProfile', name: 'UserProfile', component: UserProfile },
                        { path: 'Users', name: 'AccountUsers', component: AccountUsers },
                        { path: 'Info', name: 'AccountInfo', component: AccountInfo },
                        { path: 'Settings', name: 'AccountGeneralSettings', component: AccountGeneralSettings },
                        { path: 'MailSettings', name: 'AccountMailSettings', component: AccountMailSettings },
                        {
                            path: 'Subscriptions',
                            name: 'SubscriptionCategories',
                            component: AccountSubscriptionCategories,
                        },
                        { path: 'Tags', name: 'AccountTagManager', component: AccountTagManager },
                        { path: 'Themes', name: 'AccountThemes', component: AccountThemes },
                        { path: 'Subscription', name: 'AccountSubscription', component: AccountSubscription },
                        { path: 'BillingDetails', name: 'AccountBillingDetails', component: AccountBillingDetails },
                        { path: 'Invoices', name: 'AccountInvoices', component: AccountInvoices },
                        { path: 'CreditCards', name: 'AccountCreditCards', component: AccountCreditCards },
                        { path: 'Transactions', name: 'AccountTransactions', component: AccountTransactions },
                        { path: 'PrePaidBalance', name: 'AccountPrePaidBalance', component: AccountPrePaidBalance },
                        { path: 'ApiKeys', name: 'AccountApiKeys', component: AccountApiKeys },
                        { path: 'Connections', name: 'AccountConnections', component: AccountConnections },
                        { path: 'DataManagement', name: 'AccountDataManagement', component: AccountDataManagement },
                        { path: 'ProcessingTasks', name: 'AccountProcessingTasks', component: AccountProcessingTasks },
                    ],
                },
            ],
        },
    ];

    const router = createRouter({
        history: createWebHistory('/'),
        routes,
    });

    // Create a proper placeholder component
    const WaitingComponent = defineComponent({
        name: 'WaitingComponent',
        template: '<div>waiting</div>',
    });

    rootElement({
        name: 'vue-root', // pascal, camel & kebab-case are valid
        component: Root,
        vm: {},
        router,
        contextComponents: [Promise.resolve(WaitingComponent)],
    });
};

initVueRoot();
